
// src/web/components/template-selection-dialog.jsx

import React from 'react'
import connect from '../../connects/import-template-selection-dialog'
import {
  Dialog,
} from 'react-toolbox/lib/dialog'
import {
  Button,
} from 'react-toolbox/lib/button'
import {
  List,
  ListItem,
} from 'react-toolbox/lib/list'
import Avatar from 'react-toolbox/lib/avatar'
import ScrollableDialogPanel from './scrollable-dialog-panel.jsx'
import FontIcon from 'react-toolbox/lib/font_icon'

class ImportTemplateSelectionDialog extends React.Component {
  state = { group_id: undefined }

  onGroupClick = (group_id)=> {
    if(this.state.group_id != group_id){
      this.props.fetchTemplateList(group_id)
      this.setState({ group_id })
    }  else {
      this.setState({ group_id: undefined})
    }
  }

  render() {
    const {
      active,
      t,
      ui,
      groups,
      templates,
      onClose,
      onTemplateSelect,
      isFetching,
      fetchTemplateList,
    } = this.props

    const index = this.state.group_id ? _.findIndex(groups, (group)=> group.group_id == this.state.group_id) : undefined
    const groups_before = index >= 0 ? _.filter(groups, (group, i)=> i <= index) : groups
    const groups_after  = index >= 0 ? _.filter(groups, (group, i)=> i > index) : []

    return (
      <Dialog active={active} title={t('label:テンプレートを選択')}
          actions={[{ raised: true, label: t('label:取り消し'), onClick: onClose }]}
          onOverlayClick={onClose}
          onEscKeyDown={onClose} >
        <ScrollableDialogPanel >
          <List>
            {groups_before.map((group)=> (
              group.is_member &&
              <ListItem key={group.group_id}
                avatar={<Avatar image={group.icon_image.thumb_url} />}
                selectable={group.group_id != this.state.group_id}
                ripple={group.group_id != this.state.group_id}
                caption={group.name}
                rightIcon={group.group_id == this.state.group_id ? "expand_more" : "navigate_next"}
                onClick={()=> this.onGroupClick(group.group_id)} />
            ))}
            {index >= 0 &&
              <ListItem itemContent={(
                <List selectable ripple>
                  {!isFetching && templates && templates.map((template)=>
                    <ListItem key={template.template_id}
                      caption={template.name}
                      rightIcon=""
                      onClick={()=> onTemplateSelect(template)} />
                  )}
                  {isFetching && <ListItem caption={t('label:読み込み中')} />}
                </List>
              )}/>
            }
            {groups_after.map((group)=> (
              group.is_member &&
              <ListItem key={group.group_id}
                ripple selectable
                avatar={<Avatar image={group.icon_image.thumb_url} />}
                caption={group.name}
                rightIcon="navigate_next"
                onClick={()=> this.onGroupClick(group.group_id)} />
            ))}
          </List>
        </ScrollableDialogPanel>
      </Dialog>
    )
  }
}

export default connect(ImportTemplateSelectionDialog)



// WEBPACK FOOTER //
// ./src/web/components/import-template-selection-dialog.jsx